import AlbumSlideshowDesignerView from './AlbumSlideshowDesignerView';

export default AlbumSlideshowDesignerView;
